import { changeForBRL } from "../changeForBRL";

const doTheMath = (hourRate,multiplier) =>{
  const realValue = hourRate * multiplier;
  return changeForBRL(realValue);
}

export {doTheMath};